import { RightOutlined } from "@ant-design/icons";
import React from "react";
import { AddByKeyConditionDisplayLabel } from "../../DisplayLabelsClass";
import { useDispatch } from "react-redux";
import { KeyConditionActions } from "../../model";
import "./index.css";

export const AddByKeyConditionText = "Add by key condition";

function AddByKeyConditionOption({ setCurrentStepState, setDisplayLabels }) {
  const dispatch = useDispatch();
  function redirectToSelectKeyCondition() {
    setCurrentStepState(1);
    setDisplayLabels(new AddByKeyConditionDisplayLabel());
    dispatch(KeyConditionActions.resetSelectedUser());
  }

  return (
    <div
      className="add-by-key-condition-box add-by-key-condition-text"
      onClick={redirectToSelectKeyCondition}
    >
      <div>{AddByKeyConditionText}</div>
      <RightOutlined />
    </div>
  );
}

export default AddByKeyConditionOption;
